import { Suspense } from 'react';
import NiceModal from '@ebay/nice-modal-react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import '@/App.css';
import { routes } from '@/Routes.js';
import ModalRegistration from '@/components/Modals/ModalRegistration.tsx';
import PrivateRoute from '@/components/PrivateRoute';
import ScrollToTop from '@/components/ScrollToTop.js';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/providers/AuthProvider';

const queryClient = new QueryClient();

function AppContent() {
  return (
    <>
      <Toaster />
      <NiceModal.Provider>
        <ModalRegistration />
        <ScrollToTop />
        <Routes>
          {routes.map((route: Route) => (
            <Route
              key={route.url}
              path={route.url}
              element={route.private ? <PrivateRoute>{route.element}</PrivateRoute> : <>{route.element}</>}
            />
          ))}
        </Routes>
      </NiceModal.Provider>
    </>
  );
}

function App() {
  return (
    <Suspense fallback={<></>}>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
        <QueryClientProvider client={queryClient}>
          <RecoilRoot>
            <AuthProvider>
              <BrowserRouter>
                <AppContent />
              </BrowserRouter>
            </AuthProvider>
          </RecoilRoot>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </Suspense>
  );
}

export default App;
